import { render, staticRenderFns } from "./WECStudentForm.vue?vue&type=template&id=426885fd&scoped=true&"
import script from "./WECStudentForm.vue?vue&type=script&lang=js&"
export * from "./WECStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./WECStudentForm.vue?vue&type=style&index=0&id=426885fd&prod&scoped=true&lang=scss&"
import style1 from "./WECStudentForm.vue?vue&type=style&index=1&id=426885fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426885fd",
  null
  
)

export default component.exports